import { useSiteContext, useTranslation } from '@eti/providers';
import { TRAVELER_DETAILS_NO_TRIP_NO_CART } from '../../../constants/dataLayerEventsConstants';
import ErrorDialog from '../../../common/error-modals/ErrorDialog';

interface TravelerDetailsNoTripNoCartErrorDialogProps {
  onPrimaryAction: () => void;
  isOpen: boolean;
}

const TravelerDetailsNoTripNoCartErrorDialog = ({
  onPrimaryAction,
  isOpen,
}: TravelerDetailsNoTripNoCartErrorDialogProps) => {
  const { agencyAccount } = useSiteContext();
  const { t } = useTranslation();

  const conditionalProps = !agencyAccount
    ? { onPrimaryAction, primaryButtonLabel: t('TravelerDetails.NoTrip.Modal.ButtonText') }
    : {};

  return (
    <ErrorDialog
      content={t('TravelerDetails.NoTripOrCart.Modal.ContentText')}
      data-testid="noTrip-error-dialog"
      dataLayerEvent={TRAVELER_DETAILS_NO_TRIP_NO_CART}
      isOpen={isOpen}
      title={t('IbeClient.Error.TripNotAvailable.Header')}
      {...conditionalProps}
    />
  );
};

export default TravelerDetailsNoTripNoCartErrorDialog;
